import React from 'react';

export function NullSorting () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        stroke="#ABE1DD"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 8.5l3 3 3-3M3 3.5l3-3 3 3"
      />
    </svg>
  );
}
